// General
import "./seo-mounted.scss";

import { Helmet } from "react-helmet";

const SeoMounted = () => {
  if (window.location.hostname.endsWith(".com")) {
    return (
      <div id="seo-mounted">
        <Helmet>
          <meta
            name="keywords"
            content="sugarbook app, sugar dating app, dating site, sugar daddy app, sugar baby dating app, mobile sugar dating, verified dating app"
          />
        </Helmet>

        <h1>
          Login to Sugarbook | Connect With Verified Sugar Daddies & Sugar
          Babies Now
        </h1>
        <h2>Access Sugarbook Anytime, Anywhere</h2>
        <h2>Chat with Verified Sugar Daddies & Babies</h2>
        <h2>Find Your Perfect Match on Mobile</h2>
        <h2>Stay Secure with App-Based Dating</h2>
      </div>
    );
  } else if (window.location.hostname.endsWith(".club")) {
    return (
      <div id="seo-mounted">
        <Helmet>
          <meta name="keywords" content="sugarbook club" />
        </Helmet>

        <h1>Club</h1>
      </div>
    );
  }
};

export default SeoMounted;
